import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL9 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Gotham FC Wins 2025 NWSL Championship",
            author: "footballgirl",
             date: "January, 2026",
            image: "images/nwsl/9a.jpg",
            content: ` <p>NJ/NY Gotham FC claims second title in three years with dramatic 1-0 victory</p>
    </header>

    <article>
        <p class="byline">March 2, 2026 – San Jose, California</p>

        <p>In a thrilling conclusion to the 2025 National Women's Soccer League season, <span class="highlight">NJ/NY Gotham FC</span> hoisted the championship trophy once again, defeating the Washington Spirit 1-0 in the final match held at PayPal Park in San Jose, California, on November 22, 2025. This victory marked Gotham's second title in three seasons and etched their name in league history as the first No. 8 seed to ever win the NWSL Championship.</p>

        <h2>An Improbable Run to Glory</h2>
        <p>Entering the playoffs as the lowest seed in the expanded postseason format, Gotham embarked on an improbable Cinderella run. They upset higher-seeded opponents throughout the knockout stages, showcasing resilience, tactical discipline, and clutch performances.</p>

        <p>The championship game itself was a tense, tightly contested battle between two strong teams. Both sides displayed strong defensive efforts, with chances limited and the match remaining scoreless deep into the second half.</p>

        <h2>The Decisive Moment</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
        <p>The decisive moment arrived in the 80th minute. Substitute midfielder <strong>Bruninha</strong> delivered a precise low cross into the box, finding USWNT star <strong>Rose Lavelle</strong>, who calmly finished to give Gotham the lead. Lavelle, who was named the Championship Match MVP, sealed the win with her clinical strike, which proved to be the only goal of the game.</p>

        <p>Gotham’s backline held firm through stoppage time, frustrating the Spirit’s attempts to equalize and securing the shutout victory.</p>

        <h2>Coach and MVP Praise</h2>
        <p>Head coach Juan Carlos Amorós praised his team’s “magic moments” and relentless defensive structure, which proved crucial in containing Washington’s attack. Lavelle’s goal was described as the crowning achievement in a season full of highs for the veteran midfielder, who now has an NWSL title to add to her impressive resume.</p>

        <h2>A Historic Season</h2>
        <p>The triumph capped a historic campaign for Gotham FC, who previously won the title in 2023. The 2025 final drew a sellout crowd of 18,000 at PayPal Park and became the most-watched match in NWSL history, attracting 1.184 million viewers across broadcasts. Following the win, the team celebrated with a parade in New York City, where they were awarded the keys to the city.</p>

        <p>This championship underscores the growing competitiveness and popularity of the NWSL, with underdog stories like Gotham’s run inspiring fans nationwide.</p> 
        <header>
        <h1>哥谭FC赢得2025年NWSL冠军</h1>
        <p>新泽西/纽约哥谭FC以戏剧性的1-0胜利夺得三年内第二次冠军</p>
    </header> 
    <p>在2025年全国女子足球联赛（NWSL）赛季激动人心的收官战中，<span class="highlight">新泽西/纽约哥谭FC</span>再次捧起冠军奖杯，于2025年11月22日在加利福尼亚州圣何塞的PayPal Park以1-0击败华盛顿精神队。本次胜利标志着哥谭FC在三年内第二次夺冠，并创造了联赛历史：他们成为首支以第八种子身份赢得NWSL冠军的球队。</p>

        <h2>不可思议的逆袭之旅</h2>
        <p>作为扩军后季后赛最低种子，哥谭FC开启了一段童话般的逆袭之旅。他们在淘汰赛阶段连续爆冷击败更高排名的对手，展现出顽强的韧性、战术纪律和关键时刻的出色发挥。</p>

        <p>决赛本身是一场紧张激烈的较量，两支球队都展现出强大的防守能力，机会寥寥无几，直到下半场后期比赛仍保持0-0平局。</p>

        <h2>决定性时刻</h2>
        <p>比赛第80分钟，替补中场<strong>Bruninha</strong>送出一记精准的低平传中，找到美国女足明星<strong>Rose Lavelle</strong>，后者冷静推射破门，帮助哥谭取得领先。Lavelle被评为决赛MVP，她的这粒进球成为全场比赛唯一进球，锁定了胜局。</p>

        <p>哥谭的后防线在补时阶段稳如磐石，成功阻挡了华盛顿精神队的扳平努力，确保了零封胜利。</p>

        <h2>主帅与MVP的赞誉</h2>
        <p>主教练Juan Carlos Amorós称赞球队创造了“魔法时刻”，并强调了坚韧的防守结构在限制华盛顿进攻方面发挥的关键作用。Lavelle的进球被描述为这位资深中场在本赛季众多高光时刻中的巅峰之作，如今她又将一座NWSL冠军奖杯收入囊中。</p>

        <h2>历史性赛季</h2>
        <p>这次胜利为哥谭FC画上了一个历史性的赛季句号，他们曾在2023年首次夺冠。2025年决赛吸引了18,000名观众座无虚席，成为NWSL历史上观看人数最多的比赛，广播观众达到118.4万人。夺冠后，球队在纽约市举行了盛大的游行庆典，并获颁纽约市钥匙。</p>

        <p>本次冠军彰显了NWSL日益增强的竞争力和受欢迎程度，像哥谭这样的黑马故事激励着全国的球迷。</p>`,
                    tags: ["NWSL", "gothamcity", "ny/nj",  "paypal park"],
   
                    navIndices: { prev: 'nwsl-8', next: 'apl-1' }
        });
    }

    init() {
        console.log('ArticlePageNWSL9 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}